import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from './lib/utils';

const logoMarkVariants = cva('inline-block shrink-0', {
  variants: {
    size: {
      xs: 'size-4',
      sm: 'size-6',
      default: 'size-8',
      lg: 'size-10',
      xl: 'size-14',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

type LogoMarkProps = React.ComponentProps<'svg'> &
  VariantProps<typeof logoMarkVariants> & {
    variant?: 'default' | 'inverse';
  };

function LogoMark({
  className,
  size = 'default',
  variant = 'default',
  ...props
}: LogoMarkProps) {
  const fill = variant === 'inverse' ? '#FFFFFF' : '#000000';

  return (
    <svg
      viewBox="0 0 50 68"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(logoMarkVariants({ size }), className)}
      aria-label="Artic"
      role="img"
      {...props}
    >
      <path
        d="M0,19.8015474 C0.401029056,16.3228467 2.21196529,12.6483751 4.93593624,10.4070477 C5.03430186,10.3267314 5.75060533,9.74694796 5.81113801,9.80467531 C3.1275222,12.3798174 4.67867232,15.6803162 7.79358354,16.8976104 C11.6247982,18.3935019 15.8797417,19.3472582 19.7639225,20.7678531 C23.6481033,22.188448 26.833636,26.1816751 27.1211663,30.3731831 L27.1211663,63.5086853 C26.9294794,66.8920103 24.5434826,68.5334751 21.2444512,67.8457666 C17.3148709,66.5657253 13.339891,65.3986287 9.4304883,64.06086 C4.72659403,62.4545336 0.315274415,59.8819014 0,54.3802334 L0,19.8015474 Z"
        fill={fill}
        fillRule="nonzero"
      />
      <path
        d="M30.1452785,51.245387 L30.1452785,30.0117597 C29.7316384,24.7485308 25.8903349,19.854255 20.9745763,17.9919203 C16.9668079,16.4734398 12.6488095,15.4669759 8.62338579,13.958535 C7.21347861,13.2507475 7.05458031,12.2543231 8.62338579,11.6067728 L43.4776029,0.32985933 C46.9229217,-0.716762728 49.7704802,0.743990359 50,4.47367951 L50,37.6066718 C49.7780468,41.7178635 46.5748588,45.7637981 42.7512107,47.1969425 L30.1452785,51.2478969 Z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}

export { LogoMark, logoMarkVariants };
